import { render, staticRenderFns } from "./filtroStato.vue?vue&type=template&id=2580a41c&"
import script from "./filtroStato.vue?vue&type=script&lang=js&"
export * from "./filtroStato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports